import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import PrivateRoute from "./components/PrivateRoute";

import Markup from "./screen/Markup";
import Login from "./screen/Login";
import Home from "./screen/Home";
import Profile from "./screen/profile";

import AddBanner from "./screen/banner/AddBanner";
import BannerList from "./screen/banner/BannerList";

import AddSubadmin from "./screen/subadmin/AddSubadmin";
import SubadminList from "./screen/subadmin/SubadminList";

import AddOffer from "./screen/Offers/AddOffer";
import OfferList from "./screen/Offers/OfferList";

import SubscriberList from "./screen/subscriber/SubscriberList";
import ContactList from "./screen/contact_us/ContactList";

import AddFocus from "./screen/focus/AddFocus";
import FocusList from "./screen/focus/FocusList";

import AddBrand from "./screen/brands/AddBrand";
import BrandsList from "./screen/brands/BrandsList";

import AddProduct from "./screen/products/AddProduct";
import ProductsList from "./screen/products/ProductsList";

import AddTesto from "./screen/Testimonials/AddTesto";
import TestimonialList from "./screen/Testimonials/TestimonialList";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        {/* <Header /> */}
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<Login />} />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Markup />
              </PrivateRoute>
            }
          >
            <Route index element={<Home />} />

            <Route path="/profile" element={<Profile />} />

            <Route
              path="/add-subadmin"
              element={
                <PrivateRoute allowId={1}>
                  <AddSubadmin />
                </PrivateRoute>
              }
            />

            <Route
              path="/subadmin-list"
              element={
                <PrivateRoute allowId={1}>
                  <SubadminList />
                </PrivateRoute>
              }
            />

            <Route path="/subscribers-list" element={<SubscriberList />} />

            <Route path="/add-banner" element={<AddBanner />} />
            <Route path="/update-banner/:id?" element={<AddBanner />} />
            <Route path="/banner-list" element={<BannerList />} />

            <Route path="/add-offer" element={<AddOffer />} />
            <Route path="/update-offer/:id?" element={<AddOffer />} />
            <Route path="/offer-list" element={<OfferList />} />

            <Route path="/contact-list" element={<ContactList />} />

            <Route path="/focus-add" element={<AddFocus />} />
            <Route path="/update-focus/:id?" element={<AddFocus />} />
            <Route path="/focus-list" element={<FocusList />} />

            <Route path="/add-brand" element={<AddBrand />} />
            <Route path="/update-brand/:id?" element={<AddBrand />} />
            <Route path="/brands-list" element={<BrandsList />} />

            <Route path="/update-product/:id?" element={<AddProduct />} />
            <Route path="/add-product" element={<AddProduct />} />
            <Route path="/products-list" element={<ProductsList />} />

            <Route path="/add-testimonial" element={<AddTesto />} />
            <Route path="/update-testimonial/:id?" element={<AddTesto />} />
            <Route path="/testimonial-list" element={<TestimonialList />} />
          </Route>

          <Route path="404" element={<h1>404 Error</h1>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
